module.exports = __webpack_public_path__ + "static/media/male-red-small.b4868ba7.png";